import { render } from "./IosNew.vue?vue&type=template&id=25a45780&scoped=true"
import script from "./IosNew.vue?vue&type=script&lang=js"
export * from "./IosNew.vue?vue&type=script&lang=js"

import "../../public/wts.css?vue&type=style&index=0&id=25a45780&lang=css&scoped=true"
import "./IosNew.vue?vue&type=style&index=1&id=25a45780&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a45780"]])

export default __exports__